import { obterCargosAsync } from "../../services/cargoService";

const atualizarCargos = async ({ commit }) => {
    const cargos = await obterCargosAsync();
    commit('atualizarCargos', cargos);
}

const atualizarCargo = ({ commit }, cargo) => {
    commit('atualizarCargo', cargo);
}

export default {
    atualizarCargos,
    atualizarCargo
}